import { Component, EventEmitter, forwardRef, Input, Output, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { InyovaGrowRiskSurveyQuestion, RiskQuestionsSurveyOption } from '../../models';

@Component({
  selector: 'app-inyova-grow-investment-horizon-box',
  templateUrl: './inyova-grow-investment-horizon-box.component.html',
  styleUrls: ['./inyova-grow-investment-horizon-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InyovaGrowInvestmentHorizonBoxComponent),
      multi: true
    }
  ],
  standalone: false
})
export class InyovaGrowInvestmentHorizonBoxComponent implements ControlValueAccessor, OnInit {
  @Input() hasError: boolean;
  @Input() showShortHorizonError: boolean;
  @Input() title: string;
  @Input() hint: string;
  @Input() options: RiskQuestionsSurveyOption[];

  @Output() investmentHorizonChange: EventEmitter<{ acceptShortHorizon: boolean }> = new EventEmitter<{
    acceptShortHorizon: boolean;
  }>();

  @Output() showInfoHandler = new EventEmitter<any>();

  shortHorizon = false;
  acceptShortTerm = true;
  showHint = false;

  value: string | number = '';
  shortHorizonValue: string | number = '';
  private onChange: (value: number | string) => void;
  private onTouched: () => void;

  ngOnInit() {
    this.shortHorizonValue = this.options.find((option) => option.inyova_id === 1).id;
  }

  toggleHint() {
    this.showHint = !this.showHint;
    this.showInfoHandler.emit();
  }

  writeValue(value: number): void {
    this.value = value;
    this.acceptShortTerm = !(this.value === this.shortHorizonValue);
    this.investmentHorizonChange.emit({ acceptShortHorizon: this.acceptShortTerm });
    this.shortHorizon = this.shortHorizonValue === this.value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onOptionChange(value: number, option: InyovaGrowRiskSurveyQuestion) {
    this.shortHorizon = option.inyova_id === 1;
    this.value = value;
    this.acceptShortTerm = !(option.inyova_id === 1);
    this.investmentHorizonChange.emit({ acceptShortHorizon: this.acceptShortTerm });
    this.onChange(value);
    this.onTouched();
  }

  updateShortInvestment() {
    this.acceptShortTerm = !this.acceptShortTerm;
    this.investmentHorizonChange.emit({ acceptShortHorizon: this.acceptShortTerm });
  }
}
